
import { MoveRight } from 'lucide-react';
// @ts-ignore
import GoogleIcon from 'media/svgs/google.svg?react';
import Button from '../Button';
import { Input } from '../Input';
import Label from '../Label';
import PasswordInput from '../PasswordInput';

export type LoginFormProps = {
    loginUser: (event: any) => void;
    handleChangeLoginEmail: (event: any) => void;
    handleChangeLoginPassword: (event: any) => void;
    isLoginPending: boolean;
    email: string;
    password: string;
    handleCreateAccount: () => void;
    handleForgotPassword: () => void;
    handleGoogleLogin: () => void;
};

const LoginForm = ({
    loginUser,
    handleChangeLoginEmail,
    handleChangeLoginPassword,
    isLoginPending,
    email,
    password,
    handleCreateAccount,
    handleForgotPassword,
    handleGoogleLogin,
}: LoginFormProps) => {


    return (
        <>
            <div
                className="px-6 pt-0 pb-8 text-[14px]"
            >
                <form
                    className="mt-4 flex flex-col gap-6"
                    onSubmit={loginUser}
                >
                    <div className="flex flex-col gap-2">
                        <Label htmlFor="email" className="flex items-start">
                            Email Address{' '}
                        </Label>
                        <Input
                            value={email}
                            placeholder="Your Work Email Address"
                            type="email"
                            id="email"
                            name="email"
                            autoComplete="email"
                            onChange={handleChangeLoginEmail}
                        ></Input>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Label
                            htmlFor="password"
                            className="flex items-start"
                        >
                            Password
                        </Label>
                        <PasswordInput
                            placeholder="Password"
                            onChange={handleChangeLoginPassword}
                            required
                            value={password}
                            id="password"
                            className="w-full"
                            name="password"
                        />
                    </div>
                    <div>
                        <Button
                            type="submit"
                            loading={isLoginPending}
                            size="sm"
                            className="mb-4 w-full text-sm"
                            rightIcon={<MoveRight size={18} />}
                        >
                            Log In
                        </Button>
                        <Button
                            type="button"
                            size="sm"
                            onClick={handleGoogleLogin}
                            variant="outline"
                            className="w-full text-sm"
                            leftIcon={<GoogleIcon width={18} height={18} />}
                        >
                            Sign In with Google
                        </Button>
                    </div>
                </form>
                <div className="mt-6 flex justify-between">
                    <Button
                        variant="link"
                        size="link"
                        className="mt-2 h-5 px-0"
                        onClick={handleCreateAccount}
                    >
                        Create an Account
                    </Button>
                    <Button
                        variant="link"
                        size="link"
                        className="mt-2 h-5 px-0"
                        onClick={handleForgotPassword}
                    >
                        Forgot Your Password?
                    </Button>
                </div>
            </div>

        </>
    );
};

export default LoginForm;